import React from "react";
import {
  LinkGridBase,
  LinkGridContainer,
  LinkGridTitle,
  LinkGridItem,
} from "./link-grid.styled";
import { LinkGridSliceFragment } from "../../types/graphql";
import { SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";

export type ILinkGridProps = Slice<
  SharedSliceType,
  LinkGridSliceFragment["primary"],
  LinkGridSliceFragment["items"][number]
> & { type: SharedSliceType };

const LinkGrid = ({
  slice,
  context,
}: SliceComponentProps<ILinkGridProps, IPageContext>) => {
  const title = slice.primary?.link_grid_title;

  const grid_items =
    slice.items &&
    slice.items.map((item, index) => {
      return (
        item?.link && (
          <LinkGridItem
            key={index}
            href={item.link?.url || undefined}
            target={item.link?.target || undefined}
          >
            {item.link_text}
          </LinkGridItem>
        )
      );
    });

  return (
    (slice && (
      <LinkGridBase>
        {title && <LinkGridTitle> {title} </LinkGridTitle>}
        <LinkGridContainer>{grid_items}</LinkGridContainer>
      </LinkGridBase>
    )) || <></>
  );
};

export default LinkGrid;
